import React, { useState, useEffect } from 'react'
import { useRef } from "react";
import Slider from "react-slick";
import axios from "axios";
import { BaseUrl, getAssetUrl } from "../../helper/BaseUrl";
import { Modal } from "react-bootstrap";
import { Link } from 'react-router-dom';

const decodeHTMLEntities = (str = "") => {
  if (!str) return "";
  const entities = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"',
    apos: "'",
    nbsp: " ",
    rsquo: "’",
    lsquo: "‘",
    rdquo: "”",
    ldquo: "“",
    ndash: "–",
    mdash: "—",
    hellip: "…",
  };

  return str
    .replace(/&([a-zA-Z]+);/g, (match, entity) => {
      return entities[entity] || match;
    })
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec))
    .replace(/&#x([\da-fA-F]+);/g, (_, hex) =>
      String.fromCharCode(parseInt(hex, 16))
    );
};


const truncateText = (htmlString = "", maxLength) => {
  if (!htmlString) return "";
  const decoded = decodeHTMLEntities(htmlString);
  const plainText = decoded.replace(/<\/?[^>]+(>|$)/g, "").trim();
  if (plainText.length <= maxLength) return plainText;
  const truncated = plainText.slice(0, maxLength);
  return truncated.slice(0, truncated.lastIndexOf(" ")) + "...";
};


export default function HomeTestimonial({ category = null, initialData, isBtn=false }) {
    const sliderRef = useRef(null);
    const [allData, setAllData] = useState(initialData || []);
    const [modalShow, setModalShow] = useState(false);
    const [selectedTestimonial, setSelectedTestimonial] = useState(null);

    const categoryOrder = { interior: 1, PMS: 2, null: 3,};
    
    const filteredTestimonials = allData
    .filter(item => {
        if (!category) return true;
        return item?.testimonial_category === category;
    })
    .sort((a, b) => {
        // when category is NULL (ALL page)
        if (!category) {
        const catA = categoryOrder[a.testimonial_category ?? "null"];
        const catB = categoryOrder[b.testimonial_category ?? "null"];

        // first sort by category priority
        if (catA !== catB) {
            return catA - catB;
        }
        }

        // then always sort by rank
        return Number(a.rank || 0) - Number(b.rank || 0);
    });


    const dataFetcher = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/api/home-testimonial-section/edit`);
            setAllData(response.data.Home_testimonial_sections);
        } catch (error) {
            console.error("Data fetch error:", error);
            throw error;
        }
    };

    useEffect(() => {
        dataFetcher();
    }, [])

    if (!allData) {
        return null;
    }

    
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        cssEase: "ease",
        responsive: [
        {
            breakpoint: 991,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 767,
            settings: { slidesToShow: 1 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 1 },
        },
        ],
    };

    const CustomArrows = () => (
        <>
        <div className="default-arrow" onClick={() => sliderRef.current.slickPrev()}>
            <i className="fa-solid fa-arrow-left"></i>
        </div>
        <div className="default-arrow" onClick={() => sliderRef.current.slickNext()}>
            <i className="fa-solid fa-arrow-right"></i>
        </div>
        </>
    );


    const handleModalClose = () => {
    setModalShow(false);
    setSelectedTestimonial(null);

    sliderRef.current?.slickPlay();
    };


  return (
    <>
    <section className="hometestim">
        <div className="container">
            <div className="row">

                <div className="col-lg-6 col-md-6">
                    <div className="hometestim-head">
                        <h3 className="heading">What our clients say</h3>
                        <p>Hear from those who’ve experienced our design journey and transformation firsthand.</p>

                        {isBtn && 
                            <img src="/assets/images/google-rating.webp" alt="rating" className="landpage-rating" loading="lazy"/>
                        }

                        <div className="testimo-arrow testimo-desktop">
                            <CustomArrows />
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <Slider {...settings} ref={sliderRef} className="testimonial-slider">
                        {filteredTestimonials.map((data)=>(
                        <div className="testimonial-box" key={data._id}>
                            <div className='testi-para'>
                                <p>{truncateText(data.description, 310)}</p>
                                <Link onClick={(e) => {e.preventDefault(); setSelectedTestimonial(data); setModalShow(true); sliderRef.current?.slickPause();}} className="arrow-butn">Read More <i className="fa-solid fa-arrow-right"></i></Link>
                            </div>

                            <div className="testi-detail">
                                <div className="testibox-person">
                                    <img src={getAssetUrl(data?.client_image)} alt={data?.client_name} loading="lazy"/> 
                                    <div>
                                        <label>{data?.client_name}</label>
                                        <span>{data?.client_location}</span>
                                    </div>
                                </div>
                                {/* <img src="/assets/images/quote.webp" alt="quote" className="testi-quote" loading="lazy"/> */}
                            </div>
                        </div>  
                        ))}
                    </Slider>
             
                    <div className="testimo-arrow testimo-mobile">
                        <CustomArrows />
                    </div>
                </div>

            </div>
        </div>
    </section>


    <Modal className="testimo-popup" show={modalShow} onHide={handleModalClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body>
            <button className="testpop-close" onClick={handleModalClose}><i className="fa fa-close"></i></button>

            {selectedTestimonial && (
            <div className="testimo-popdata">
                <div className='testimo-popimage'>
                    <img src={getAssetUrl(selectedTestimonial.client_image)} alt={selectedTestimonial.client_name}/>
                    <div>
                        <label>{selectedTestimonial.client_name}</label>
                        <span>{selectedTestimonial.client_location}</span>
                    </div>
                </div>
                <div dangerouslySetInnerHTML={{__html: selectedTestimonial.description,}}/>
            </div>
            )}
        </Modal.Body>
      </Modal> 
    </>
  )
}
